<!-- CustomizeSection.vue - Section for customizing the product -->
<template>
  <div class="customize-section">
    <h3 class="section-title">Customize Your Product</h3>
    
    <div class="customization-options">
      <!-- TODO: Migrate components:
           - ImprintLocation.vue (location selection)
           - UploadImage.vue (image upload)
           - CustomQty.vue (if needed)
      -->
      <p class="placeholder">Customization options will go here</p>
      
      <div class="migration-notes">
        <h4>Components to migrate:</h4>
        <ul>
          <li>ImprintLocation.vue - Choose imprint location</li>
          <li>UploadImage.vue - Upload artwork</li>
          <li>Text input fields</li>
          <li>Preview functionality</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomizeSection',
  
  data() {
    return {
      location: null,
      artwork: null,
      text: ''
    }
  },
  
  methods: {
    handleLocationChange(location) {
      this.location = location
      this.$emit('location-changed', location)
    },
    
    handleArtworkUpload(file) {
      this.artwork = file
      this.$emit('artwork-uploaded', file)
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/utils' as *;

.customize-section {
  padding: 20px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: $color-text;
}

.customization-options {
  // Styles will be added during migration
}

.placeholder {
  padding: 40px;
  text-align: center;
  background: $color-bg-light;
  border: 2px dashed $color-border-dark;
  color: $color-text-light;
  margin-bottom: 16px;
}

.migration-notes {
  padding: 16px;
  background: #fff8e1;
  border-left: 4px solid #ffc107;
  
  h4 {
    margin: 0 0 8px 0;
    font-size: 14px;
    color: #f57c00;
  }
  
  ul {
    margin: 0;
    padding-left: 20px;
    font-size: 13px;
    color: $color-text-light;
    
    li {
      margin: 4px 0;
    }
  }
}
</style>
